import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled.div`
  color: ${myPalette.midnightBlue.main};

  h1 {
    font-size: 16px;
    font-weight: 700;
  }

  h3 {
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 16px;
  }

  p,
  a {
    margin: 0;
    padding: 0;
  }

  a {
    color: ${myPalette.blue.main};
    padding: 0;
    text-decoration: none;
    font-weight: 500;
    white-space: nowrap;
  }
`
